import React from 'react';

import { Stream } from '$partials/modules';
import HeroCarousel from '$partials/global/hero-carousel';
import Header from '$partials/global/header';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HomePage}
 */
const HomePage = (props) => {
    const page = props.data?.page || {};
    const navigation = props.data?.navigation || {};
    const header = props.data?.header || {};
    const signate = props.data?.signate || {};
    const hasHeroCarousel = page?.heroCarousel?.length > 0;

    const propertyListing = props.data?.propertyListing;
    const rentalPropertyListing = props.data?.rentalPropertyListing;

    return (
        <>
            {hasHeroCarousel && <HeroCarousel items={page?.heroCarousel} /> }
            <Header
                hasFeatureCarousel={hasHeroCarousel}
                logo={header?.logo}
                pageType={page?.__typename}
                propertyListing={propertyListing}
                rentalPropertyListing={rentalPropertyListing}
                signate={signate?.signate}
                {...navigation}/>
            <main className={`container${hasHeroCarousel ? ' home-page' : ''}`}>
                {/* modules */}
                <Stream
                    modules={page?.modules}
                    namespace='homepage' />
            </main>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default HomePage;
